"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var context_1 = __importDefault(require("atomicComponents/organisms/Dropdown/context"));
var DropdownWithExpandBtn_1 = __importDefault(require("atomicComponents/organisms/Dropdown/DropdownWithExpandBtn"));
var hooks_1 = require("containers/ConfirmationModal/hooks");
var CategoryTitle_1 = __importDefault(require("containers/Navbar/styles/CategoryTitle"));
var DropdownOption_1 = __importDefault(require("shared/components/DropdownMenu/DropdownOption"));
var single_1 = require("utils/selectors/single");
var utils_1 = require("./utils");
var InvoicesDropdown = function (_a) {
    var items = _a.items;
    var closeMenu = react_1.default.useContext(context_1.default).closeMenu;
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var dateToday = (0, end2end_1.getISODate)(new Date());
    var prompt = (0, hooks_1.useConfirm)();
    var downloadInvoices = function () {
        if (!items) {
            prompt('No invoices found.', '', 'red', 'OK', true);
            return;
        }
        (0, utils_1.exportInvoices)(items, "Rechargly - ".concat(company === null || company === void 0 ? void 0 : company.name, "'s Invoices ").concat(dateToday, ".csv"));
        closeMenu();
    };
    var downloadLineItems = function () {
        if (!items) {
            prompt('No line items found.', '', 'red', 'OK', true);
            return;
        }
        var lineItems = items.flatMap(function (invoice) { return invoice.lineItems.map(function (lineItem, key) { return (__assign(__assign({}, lineItem), { taxName: invoice.taxName, invoiceNumber: (0, end2end_1.getInvoiceCode)(invoice), position: key + 1 })); }); });
        (0, utils_1.exportLineItems)(lineItems, "Rechargly - ".concat(company === null || company === void 0 ? void 0 : company.name, "'s Line Items ").concat(dateToday, ".csv"));
        closeMenu();
    };
    return ((0, jsx_runtime_1.jsxs)(DropdownWithExpandBtn_1.default, __assign({ closeOnClick: true }, { children: [(0, jsx_runtime_1.jsx)(CategoryTitle_1.default, __assign({ px: 2 }, { children: "Exports" })), (0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Export invoices", autoFocus: true, onClick: downloadInvoices }), (0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Export line items", autoFocus: true, onClick: downloadLineItems })] })));
};
exports.default = InvoicesDropdown;
